import { useState, useEffect, useContext } from "react";
import FNF from "../../images/FNf.png";

import FN2 from "../../images/FNU.png";
import imageplaceholder from "../../images/placeholder.png";
import jsPDF from "jspdf";
import "jspdf-autotable"; // Import for table creation
import axios from "axios";
import { addFontsToPDF } from "./Pdfhelper";

import { getFontForText } from "./Pdfhelper";
import frontendedit from "../../images/FRONTPAGES/CDAC FRONT FAKE NEWS.png";
import { MyContext } from "../../MyContextApi";
import { formatDateTime } from "./Helpers/DateTimeHelper";

export default function PrintAdvanceFactCheckReport(
  factCheckServerResponse,
  setFactLoading,
  toDateTimeFormatted
) {
  const dateLabel = formatDateTime(toDateTimeFormatted).formattedDate;
  function getFormattedDate() {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
  }

  function getVerdictColor(verdict) {
    return verdict ? [34, 139, 34] : [220, 20, 60]; // Green for true, Red for false
  }

  function getVerdictText(verdict) {
    return verdict ? "TRUE" : "FALSE";
  }

  async function loadImageAsBase64(imageUrl) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";

      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = img.width;
          canvas.height = img.height;

          ctx.drawImage(img, 0, 0);
          const base64Data = canvas.toDataURL("image/jpeg", 0.8);
          resolve({
            data: base64Data,
            width: img.width,
            height: img.height,
          });
        } catch (error) {
          console.warn("Failed to convert image to base64:", error);
          resolve(null);
        }
      };

      img.onerror = () => {
        console.warn("Failed to load image:", imageUrl);
        resolve(null);
      };

      // Timeout fallback
      setTimeout(() => {
        console.warn("Image loading timeout:", imageUrl);
        resolve(null);
      }, 10000);

      // Direct image loading without proxy
      img.src = imageUrl;
    });
  }

  async function addClaimPage(pdf, factData, claimIndex, totalClaims) {
    const pageWidth = pdf.internal.pageSize.getWidth();
    let yPosition = 40;
    // Claim number and title - Centered
    pdf.setFontSize(20);
    pdf.setFont(undefined, "bold");
    pdf.setTextColor(41, 58, 102);

    const title = `Fact Check Analysis #${claimIndex + 1}`;
    const textWidth = pdf.getTextWidth(title);
    const xCentered = (pageWidth - textWidth) / 2;

    pdf.text(title, xCentered, yPosition);
    yPosition += 20;

    // Verdict Badge
    pdf.setTextColor(0, 0, 0); // Black color for label
    pdf.setFontSize(14);
    pdf.setFont(undefined, "bold");
    pdf.text("FINAL OUTCOME:", 20, yPosition + 8);

    // Calculate label width for positioning
    const labelWidth = pdf.getTextWidth("FINAL OUTCOME: ");

    // Set verdict text color based on value
    const verdictColor = factData.final_verdict ? [76, 175, 80] : [244, 67, 54]; // Green for true, red for false
    pdf.setTextColor(...verdictColor);

    // Position verdict text after the label
    const verdictText = getVerdictText(factData.final_verdict);
    const textX = 20 + labelWidth + 2; // Small spacing after label
    pdf.setFontSize(14); // Font size for TRUE/FALSE
    pdf.text(verdictText, textX, yPosition + 8);
    yPosition += 27;
    // Claim section
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(14);
    pdf.setFont(undefined, "bold");
    pdf.text("CLAIM UNDER INVESTIGATION:", 20, yPosition);
    yPosition += 10;

    pdf.setFontSize(12);
    pdf.setFont(undefined, "normal");
    pdf.setTextColor(50, 50, 50);
    const claimLines = pdf.splitTextToSize(
      `"${factData.claim}"`,
      pageWidth - 40
    );
    pdf.text(claimLines, 20, yPosition);
    yPosition += claimLines.length * 6 + 15;

    // Analysis section
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(14);
    pdf.setFont(undefined, "bold");
    pdf.text("DETAILED ANALYSIS:", 20, yPosition);
    yPosition += 10;

    pdf.setFontSize(11);
    pdf.setFont(undefined, "normal");
    pdf.setTextColor(40, 40, 40);
    const factLines = pdf.splitTextToSize(factData.fact, pageWidth - 40);
    pdf.text(factLines, 20, yPosition);
    yPosition += factLines.length * 5 + 20;

    // Try to load an image from imageLink array or fallback to placeholder
    let imageData = null;

    if (factData.imageLink && factData.imageLink.length > 0) {
      for (let imgUrl of factData.imageLink) {
        imageData = await loadImageAsBase64(imgUrl);
        if (imageData && imageData.data) {
          //  
          break;
        }
      }
    }

    if (!imageData || !imageData.data) {
      console.warn(
        `All image links failed for claim ${claimIndex + 1}, using placeholder`
      );
      imageData = await loadImageAsBase64(imageplaceholder);
    }

    if (imageData && imageData.data) {
      try {
        if (yPosition > 220) {
          pdf.addPage();
          yPosition = 40;
        }

        const maxWidth = pageWidth - 30;
        const maxHeight = 70;

        let imgWidth = maxWidth;
        let imgHeight = (imageData.height * imgWidth) / imageData.width;

        if (imgHeight > maxHeight) {
          imgHeight = maxHeight;
          imgWidth = (imageData.width * imgHeight) / imageData.height;
        }

        const xPosition = (pageWidth - imgWidth) / 2;

        // Add single rounded border
        const borderPadding = 8;
        const borderRadius = 6;

        // Add background with rounded corners
        pdf.setFillColor(245, 245, 245); // Light gray background
        pdf.roundedRect(
          xPosition - borderPadding,
          yPosition - borderPadding,
          imgWidth + borderPadding * 2,
          imgHeight + borderPadding * 2,
          borderRadius,
          borderRadius,
          "F"
        );

        // Add single elegant border with rounded corners
        pdf.setDrawColor(200, 200, 200); // Light border
        pdf.setLineWidth(0.5);
        pdf.roundedRect(
          xPosition - borderPadding,
          yPosition - borderPadding,
          imgWidth + borderPadding * 2,
          imgHeight + borderPadding * 2,
          borderRadius,
          borderRadius,
          "S"
        );

        // Add the image
        pdf.addImage(
          imageData.data,
          "JPEG",
          xPosition,
          yPosition,
          imgWidth,
          imgHeight
        );

        // Make image clickable - add link annotation with new tab behavior
        const imageUrl = imageData.originalUrl || imageData.data; // Use original URL if available
        pdf.link(
          xPosition - borderPadding,
          yPosition - borderPadding,
          imgWidth + borderPadding * 2,
          imgHeight + borderPadding * 2,
          { url: imageUrl, target: "_blank" }
        );

        yPosition += imgHeight + borderPadding * 2 + 15; // Account for border and spacing
      } catch (error) {
        console.warn(
          `Error adding image to PDF for claim ${claimIndex + 1}:`,
          error
        );
      }
    }
  }

  function addSourcesPage(pdf, factData) {
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const leftColumnX = 10;
    const rightColumnX = pageWidth / 2 + 10;
    const columnWidth = pageWidth / 2 - 25;
    let leftYPosition = 40;
    let rightYPosition = 40;

    // Page title
    pdf.setFontSize(18);
    pdf.setFont(undefined, "bold");
    pdf.setTextColor(41, 58, 102);
    pdf.text(`Sources & References`, pageWidth / 2, 30, { align: "center" });

    // Draw vertical separator line
    pdf.setDrawColor(200, 200, 200);
    pdf.setLineWidth(0.5);
    pdf.line(pageWidth / 2, 35, pageWidth / 2, pageHeight - 20);

    // Left Column - Sources Section
    leftYPosition = 45;

    // Sources header
    pdf.setFillColor(240, 248, 255);
    pdf.rect(leftColumnX, leftYPosition - 8, columnWidth, 12, "F");
    pdf.setTextColor(41, 58, 102);
    pdf.setFontSize(14);
    pdf.setFont(undefined, "bold");
    pdf.text("SOURCES", leftColumnX + 5, leftYPosition);

    leftYPosition += 20;

    // Display up to 10 sources in left column
    const maxSources = Math.min(
      factData.sources && factData.sources.length,
      10
    );
    const availableHeight = pageHeight - leftYPosition - 30;
    const sourceHeight = availableHeight / 10; // Fixed height for 10 items

    factData.sources.slice(0, maxSources).forEach((source, index) => {
      const sourceStartY = leftYPosition + index * sourceHeight;

      // Source number badge
      pdf.setFillColor(41, 58, 102);
      pdf.circle(leftColumnX + 7, sourceStartY + 3, 3, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(8);
      pdf.setFont(undefined, "bold");
      pdf.text(`${index + 1}`, leftColumnX + 7, sourceStartY + 4, {
        align: "center",
      });

      // Title (more compact)
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(8); // Reduced from 9
      pdf.setFont(undefined, "bold");
      const title = source.title || "No title available";
      const titleLines = pdf.splitTextToSize(title, columnWidth - 20);
      const displayTitle = titleLines.length > 1 ? [titleLines[0]] : titleLines;
      if (titleLines.length > 1) {
        displayTitle[0] =
          displayTitle[0].substring(0, displayTitle[0].length - 3) + "...";
      }
      pdf.text(displayTitle, leftColumnX + 15, sourceStartY + 2);

      // URL (domain only)
      pdf.setTextColor(0, 100, 200);
      pdf.setFontSize(7); // Reduced from 8
      pdf.setFont(undefined, "normal");
      const urlY = sourceStartY + 2 + displayTitle.length * 3 + 2; // Reduced spacing

      try {
        const domain = new URL(source.link).hostname;
        pdf.textWithLink(domain, leftColumnX + 15, urlY, { url: source.link });
      } catch {
        const shortUrl =
          source.link.length > 30
            ? source.link.substring(0, 30) + "..."
            : source.link;
        pdf.textWithLink(shortUrl, leftColumnX + 15, urlY, {
          url: source.link,
        });
      }

      // Separator line between sources (except last one)
      if (index < maxSources - 1) {
        pdf.setDrawColor(230, 230, 230);
        pdf.setLineWidth(0.2);
        pdf.line(
          leftColumnX + 5,
          sourceStartY + sourceHeight - 7,
          leftColumnX + columnWidth - 5,
          sourceStartY + sourceHeight - 7
        );
      }
    });

    // Don't fill empty slots - just leave them blank

    // Right Column - Social Links Section
    rightYPosition = 45;

    // Social links header
    pdf.setFillColor(248, 240, 255);
    pdf.rect(rightColumnX, rightYPosition - 8, columnWidth, 12, "F");
    pdf.setTextColor(41, 58, 102);
    pdf.setFontSize(14);
    pdf.setFont(undefined, "bold");
    pdf.text("SOCIAL MEDIA", rightColumnX + 5, rightYPosition);

    rightYPosition += 20;

    if (factData.social_links && factData.social_links.length > 0) {
      // Display up to 10 social links in right column
      const maxSocialLinks = Math.min(factData.social_links.length, 10);
      const socialLinkHeight = availableHeight / 10; // Fixed height for 10 items

      factData.social_links
        .slice(0, maxSocialLinks)
        .forEach((socialLink, index) => {
          const socialStartY = rightYPosition + index * socialLinkHeight;

          // Social platform icon/badge
          pdf.setFillColor(200, 0, 100);
          pdf.circle(rightColumnX + 7, socialStartY + 3, 3, "F");
          pdf.setTextColor(255, 255, 255);
          pdf.setFontSize(8);
          pdf.setFont(undefined, "bold");
          pdf.text("S", rightColumnX + 7, socialStartY + 4, {
            align: "center",
          });

          // Title (more compact)
          pdf.setTextColor(0, 0, 0);
          pdf.setFontSize(8); // Reduced from 9
          pdf.setFont(undefined, "bold");
          const title = socialLink.title || "No title available";
          const titleLines = pdf.splitTextToSize(title, columnWidth - 20);
          const displayTitle =
            titleLines.length > 1 ? [titleLines[0]] : titleLines;
          if (titleLines.length > 1) {
            displayTitle[0] =
              displayTitle[0].substring(0, displayTitle[0].length - 3) + "...";
          }
          pdf.text(displayTitle, rightColumnX + 15, socialStartY + 2);

          // Platform/URL
          pdf.setTextColor(200, 0, 100);
          pdf.setFontSize(7); // Reduced from 8
          pdf.setFont(undefined, "normal");

          try {
            const domain = new URL(socialLink.link).hostname;
            const platform = domain.includes("twitter")
              ? "Twitter"
              : domain.includes("facebook")
              ? "Facebook"
              : domain.includes("instagram")
              ? "Instagram"
              : domain.includes("linkedin")
              ? "LinkedIn"
              : domain.includes("youtube")
              ? "YouTube"
              : domain;

            const domainX = rightColumnX + 15;
            const domainY = socialStartY + 2 + displayTitle.length * 3 + 2; // Reduced spacing

            pdf.text(platform, domainX, domainY);

            // Calculate width and height for clickable area
            const textWidth = pdf.getTextWidth(platform);
            const textHeight = 8;

            // Add clickable link
            pdf.link(domainX, domainY - 6, textWidth, textHeight, {
              url: socialLink.link,
            });
          } catch {
            const shortUrl =
              socialLink.link.length > 25
                ? socialLink.link.substring(0, 25) + "..."
                : socialLink.link;
            const domainX = rightColumnX + 15;
            const domainY = socialStartY + 2 + displayTitle.length * 3 + 2;

            pdf.text(shortUrl, domainX, domainY);

            const textWidth = pdf.getTextWidth(shortUrl);
            const textHeight = 8;
            pdf.link(domainX, domainY - 6, textWidth, textHeight, {
              url: socialLink.link,
            });
          }

          // Separator line
          if (index < maxSocialLinks - 1) {
            pdf.setDrawColor(230, 230, 230);
            pdf.setLineWidth(0.2);
            pdf.line(
              rightColumnX + 5,
              socialStartY + socialLinkHeight - 7,
              rightColumnX + columnWidth - 5,
              socialStartY + socialLinkHeight - 7
            );
          }
        });

      // Don't fill empty slots - just leave them blank
    } else {
      // No social links available message
      pdf.setFillColor(248, 248, 248);
      pdf.rect(rightColumnX, rightYPosition - 8, columnWidth, 12, "F");
      pdf.setTextColor(41, 58, 102);
      pdf.setFontSize(14);
      pdf.setFont(undefined, "bold");
      pdf.text("SOCIAL MEDIA", rightColumnX + 5, rightYPosition);
      rightYPosition += 20;

      pdf.setTextColor(150, 150, 150);
      pdf.setFontSize(11);
      pdf.setFont(undefined, "italic");
      pdf.text(
        "No social media references",
        rightColumnX + 5,
        rightYPosition + 20
      );
      pdf.text("found for this claim.", rightColumnX + 5, rightYPosition + 35);
    }
  }

  async function generatePDF() {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Determine if we have single object or array
      const factDataArray = Array.isArray(factCheckServerResponse)
        ? factCheckServerResponse
        : [factCheckServerResponse];

      const totalClaims = factDataArray.length;

      // Collect first image from each fact data for preloading
      const allImagePromises = [];
      factDataArray.forEach((factData, index) => {
        if (factData.imageLink && factData.imageLink.length > 0) {
          allImagePromises.push(loadImageAsBase64(factData.imageLink[0]));
        }
      });

      // Wait for all first images to load before proceeding
      await Promise.all(allImagePromises);
      // Add cover page
      if (typeof frontendedit !== "undefined") {
        pdf.addImage(frontendedit, "JPEG", 0, 0, pageWidth, pageHeight);

        // Add title on cover if dateLabel exists
        if (typeof dateLabel !== "undefined") {
          pdf.setTextColor(41, 58, 102, 255);
          pdf.setFontSize(26);
          pdf.setFont(undefined, "bold");
          pdf.text(`${dateLabel}`, 125, 207);
        }
      } else {
        // Create a simple cover page

        pdf.setFillColor(41, 58, 102);
        pdf.rect(0, 0, pageWidth, pageHeight, "F");

        pdf.setTextColor(255, 255, 255);
        pdf.setFontSize(28);
        pdf.setFont(undefined, "bold");
        pdf.text("ADVANCED FACT CHECK", pageWidth / 2, pageHeight / 2 - 20, {
          align: "center",
        });
        pdf.text("INVESTIGATION REPORT", pageWidth / 2, pageHeight / 2, {
          align: "center",
        });

        pdf.setFontSize(16);
        pdf.setFont(undefined, "normal");
        pdf.text(
          `Generated on ${getFormattedDate()}`,
          pageWidth / 2,
          pageHeight / 2 + 30,
          { align: "center" }
        );
        pdf.text(
          `Total Claims Analyzed: ${totalClaims}`,
          pageWidth / 2,
          pageHeight / 2 + 45,
          { align: "center" }
        );
      }

      // Generate pages for each fact check object
      for (let index = 0; index < factDataArray.length; index++) {
        const factData = factDataArray[index];

        // Add claim page with background
        pdf.addPage();
        pdf.addImage(FN2, "JPEG", 0, 0, pageWidth, pageHeight);
        await addClaimPage(pdf, factData, index, totalClaims);

        // Add sources page with background
        pdf.addPage();
        pdf.addImage(FN2, "JPEG", 0, 0, pageWidth, pageHeight);
        addSourcesPage(pdf, factData, index, totalClaims);
      }

      // Save the PDF
      // const fileName =
      //   typeof dateLabel !== "undefined"
      //     ? `Advanced_Fact_Check_Report_${dateLabel}.pdf`
      //     : `Advanced_Fact_Check_Report_${getFormattedDate().replace(
      //         /\//g,
      //         "-"
      //       )}.pdf`;
      // pdf.save(fileName);
      const fileName =
        typeof dateLabel !== "undefined"
          ? `CSMART_Fake_News_Report_${dateLabel}.pdf`
          : `CSMART_Fake_News_Report_${getFormattedDate().replace(
              /\//g,
              "-"
            )}.pdf`;
      pdf.save(fileName);
      setFactLoading(false);

      return true;
    } catch (error) {
      console.error("Error generating advanced fact check report:", error);
      setFactLoading(false);
      return false;
    }
  }

  // Call the async function
  return generatePDF();
}
